module.exports = __webpack_public_path__ + "cb33834b058bf34d881ba594550c5b7f.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1186
// module chunks = 1